import customSelect from 'custom-select';
import { createApp } from 'vue'
import Select2 from 'vue3-select2-component';

document.addEventListener('DOMContentLoaded', () => {

    const el = document.querySelectorAll('.js-dropdown');

    const initFilterApp = function (el) {
        const startCategory = el.dataset.category;

        const getCategories = function (data) {
            const categories = [];

            data.forEach(item => {
                if(!item)
                    return;

                let category = item.split('/');

                category.forEach(((cat,x)=> {
                    if(cat.trim() !== ''){
                        if(x)
                            categories.push(item);
                        else
                            categories.push(cat.trim());
                    }
                }));
            });

            return  categories.filter((value, index, self) => self.indexOf(value) === index).sort((a, b) => a.localeCompare(b));
        }

        const app = createApp({
            data() {
                return {
                    orderByValues: ['Najpopularniejsze','Nazwa [A-Z]', 'Nazwa [Z-A]'],
                    items: [],
                    filteredItems: [],
                    countries: [],
                    countriesFiltered: [],
                    manufacturers: [],
                    manufacturersFiltered: [],
                    collections: [],
                    collectionsFiltered: [],
                    categories: [],
                    categoriesFiltered: [],

                    orderBy: 'Najpopularniejsze',
                    country: null,
                    manufacturer: null,
                    collection: null,
                    category: null,
                    is_new: el.dataset.newsOnly ,

                    init: false,

                    is_refreshing: false,
                    is_flat_categories: true,
                    is_loaded: false,

                    // pagination vars
                    showPagination: false,
                    currentPage: 1,
                    totalPages: 1,
                    perPage: 12,
                    indexOfLastOffer: 1,
                    indexOfFirstOffer: 1,
                    currentItems: [],
                    showPages: [],
                }
            },
            mounted() {
                this.loadData();
                if(document.getElementById('app-collections'))
                    init();
            },
            watch:{
                perPage(){
                    if(this.init)
                        this.currentPage = 1;
                    this.saveUrl();
                    this.reloadPagination();
                },
                is_new(){
                    if(this.init)
                        this.currentPage = 1;
                    this.filter();
                },
                country(){
                    if (this.country === 'Wszystkie') this.country = null;
                    if(this.init)
                        this.currentPage = 1;
                    this.filter();
                },
                manufacturer(){
                    if (this.manufacturer === 'Wszystkie') this.manufacturer = null;
                    if(this.init)
                        this.currentPage = 1;
                    this.filter();
                },
                collection(){
                    if (this.collection === 'Wszystkie') this.collection = null;
                    if(this.init)
                        this.currentPage = 1;
                    this.filter();
                },
                category(){
                    if (this.category === 'Wszystkie') this.category = null;
                    if(this.init)
                        this.currentPage = 1;
                    this.filter();
                },
                orderBy(){
                    this.filter();
                }
            },
            computed:{
                filterCounter(){
                    let i = 0;
                    if(this.country) i++;
                    if(this.manufacturer) i++;
                    if(this.collection) i++;
                    if(this.category) i++;
                    if(this.is_new) i++;
                    return i;
                }
            },
            methods: {
                loadData() {
                    fetch(el.dataset.url)
                        .then(response => response.json())
                        .then(data => {
                            this.items = data.items;
                            this.filteredItems = data.items.sort((a, b) => {
                                if(a.order !== b.order)
                                    return a.order - b.order;
                                if(a.secondary_order !== b.secondary_order)
                                    return a.secondary_order - b.secondary_order;
                                return a.title.localeCompare(b.title);
                            });

                            // this.countries = data.countries.sort((a, b) => a.localeCompare(b));
                            this.countries = data.items.map(item => item.country).filter((value, index, self) => self.indexOf(value) === index).sort((a, b) => a.localeCompare(b));
                            this.countries.unshift('Wszystkie');
                            // this.manufacturers = data.manufacturers.sort((a, b) => a.localeCompare(b));
                            this.manufacturers = data.items.map(item => item.manufacturer).filter((value, index, self) => self.indexOf(value) === index).sort((a, b) => a.localeCompare(b));
                            this.manufacturers.unshift('Wszystkie');
                            // this.collections = data.collections.sort((a, b) => a.localeCompare(b));
                            this.collections = data.items.map(item => item.name).filter((value, index, self) => self.indexOf(value) === index).sort((a, b) => a.localeCompare(b));
                            this.collections.unshift('Wszystkie');

                            this.countriesFiltered = this.countries;
                            this.manufacturersFiltered = this.manufacturers;
                            this.collectionsFiltered = this.collections;

                            if(this.is_new){
                                this.filteredItems = this.filteredItems.filter(item => item.is_new === 1);
                            }



                            this.categories = data.items.map(item =>{
                                if(item.category.indexOf('/') !== -1){
                                    this.is_flat_categories = false;
                                }

                                return item.category;
                            }).filter((value, index, self) => self.indexOf(value) === index).sort((a, b) => a.localeCompare(b));
                            this.categories = getCategories(this.categories);
                            this.categories.unshift('Wszystkie');

                            if(startCategory){
                                this.category = startCategory;
                            }

                            this.categoriesFiltered = this.categories;

                            this.loadSettingsFromUrl();

                            this.reloadPagination();
                            this.is_loaded = true;

                            setTimeout(() => {
                                if(this.currentPage > 1 && this.currentItems.length == 0){
                                    this.currentPage = 1;
                                    this.saveUrl();
                                    this.reloadPagination();
                                }

                            }, 0);

                            if(!this.is_flat_categories){
                                document.body.classList.add('subcategories-exists');
                            }
                        });
                },

                selectCountry(value){
                    this.country = value;
                    this.$refs.countries.removeAttribute('open');
                    this.filter();
                },
                selectManufacture(value){
                    this.manufacturer = value;
                    this.$refs.manufacturer.removeAttribute('open');
                    this.filter();
                },
                selectCollection(value){
                    this.collection = value;
                    this.$refs.collections.removeAttribute('open');
                    this.filter();
                },
                selectCategory(value){
                    this.category = value;
                    this.$refs.categories.removeAttribute('open');
                    this.filter();
                },
                selectPagination(value){
                    this.perPage = value;
                    this.reloadPagination();
                },

                filter(){
                    this.filteredItems = this.items;

                    if(this.country)
                        this.filteredItems = this.filteredItems.filter(item => item.country === this.country);
                    if(this.manufacturer)
                        this.filteredItems = this.filteredItems.filter(item => item.manufacturer === this.manufacturer);
                    if(this.collection)
                        this.filteredItems = this.filteredItems.filter(item => item.name === this.collection);
                    if(this.category)
                        this.filteredItems = this.filteredItems.filter(item => item.category.includes(this.category));
                    if(this.is_new){
                        this.filteredItems = this.filteredItems.filter(item => item.is_new === 1);
                    }

                    this.collectionsFiltered = this.items.map(item => {
                        let matched = 0;
                        let found = 0;

                        if(this.manufacturer) {
                            found++;
                            if(item.manufacturer === this.manufacturer)
                                matched++;
                        }

                        if(this.country) {
                            found++;
                            if(item.country === this.country)
                                matched++;
                        }

                        if(this.category) {
                            found++;
                            if(item.category.includes(this.category))
                                matched++;
                            // if(item.category === this.category)
                            //     matched++;
                        }

                        if(matched === found)
                            return item.name;

                    }).filter((value, index, self) => self.indexOf(value) === index);
                    this.collectionsFiltered.sort((a, b) => a.localeCompare(b));
                    this.collectionsFiltered.unshift('Wszystkie');

                    this.manufacturersFiltered = this.items.map(item => {
                        let matched = 0;
                        let found = 0;

                        if(this.collection) {
                            found++;
                            if(item.name === this.collection)
                                matched++;
                        }

                        if(this.country) {
                            found++;
                            if(item.country === this.country)
                                matched++;
                        }

                        if(this.category) {
                            found++;
                            if(item.category.includes(this.category))
                                matched++;
                            // if(item.category === this.category)
                            //     matched++;
                        }

                        if(matched === found)
                            return item.manufacturer;
                    }).filter((value, index, self) => self.indexOf(value) === index);
                    this.manufacturersFiltered.sort((a, b) => a.localeCompare(b));
                    this.manufacturersFiltered.unshift('Wszystkie');


                    this.countriesFiltered = this.items.map(item => {
                        let matched = 0;
                        let found = 0;

                        if(this.collection) {
                            found++;
                            if(item.name === this.collection)
                                matched++;
                        }

                        if(this.manufacturer) {
                            found++;
                            if(item.manufacturer === this.manufacturer)
                                matched++;
                        }

                        if(this.category) {
                            found++;
                            if(item.category.includes(this.category))
                                matched++;
                        }

                        if(matched === found)
                            return item.country;
                    }).filter((value, index, self) => self.indexOf(value) === index);
                    this.countriesFiltered.sort((a, b) => a.localeCompare(b));
                    this.countriesFiltered.unshift('Wszystkie');

                    this.categoriesFiltered = this.items.map(item => {
                        let matched = 0;
                        let found = 0;

                        if(this.collection) {
                            found++;
                            if(item.name === this.collection)
                                matched++;
                        }

                        if(this.manufacturer) {
                            found++;
                            if(item.manufacturer === this.manufacturer)
                                matched++;
                        }

                        if(this.country) {
                            found++;
                            if(item.country === this.country)
                                matched++;
                        }

                        if(matched === found)
                            return item.category;
                    }).filter((value, index, self) => self.indexOf(value) === index);
                    this.categoriesFiltered.sort((a, b) => a.localeCompare(b));
                    this.categoriesFiltered = getCategories(this.categoriesFiltered);
                    this.categoriesFiltered.unshift('Wszystkie');

                    switch(this.orderBy){
                        case 'Nazwa [A-Z]':
                            this.filteredItems.sort((a, b) => a.title.localeCompare(b.title));
                            break;
                        case 'Nazwa [Z-A]':
                            this.filteredItems.sort((a, b) => b.title.localeCompare(a.title));
                            break;
                        case 'Najpopularniejsze':
                            this.filteredItems.sort((a, b) => {
                                if(a.order !== b.order)
                                    return a.order - b.order;
                                if(a.secondary_order !== b.secondary_order)
                                    return a.secondary_order - b.secondary_order;
                                return a.title.localeCompare(b.title);
                            });

                            break;
                        // case 'Najpopularniejsze [Z-A]':
                        //     this.filteredItems.sort((a, b) => {
                        //         if(a.order !== b.order)
                        //             return b.order - a.order;
                        //
                        //         return b.title.localeCompare(a.title);
                        //     });
                        //     break;
                        default:
                            this.filteredItems.sort((a, b) => {
                                if(a.order !== b.order)
                                    return a.order - b.order;
                                if(a.secondary_order !== b.secondary_order)
                                    return a.secondary_order - b.secondary_order;
                                return a.title.localeCompare(b.title);
                            });
                    }


                    this.saveUrl();
                    this.reloadPagination();
                },
                clearFilter(){
                    this.orderBy = 'Nazwa [A-Z]';
                    this.country = null;
                    this.manufacturer = null;
                    this.collection = null;
                    this.category = null;
                    this.filteredItems = this.items;
                    this.is_new = false;
                    this.currentPage = 1;
                    this.saveUrl();
                    this.reloadPagination();
                },

                reloadPagination: function() {
                    this.currentItems = [];
                    this.is_refreshing = true;

                    this.totalPages = Math.ceil(this.filteredItems.length / this.perPage);
                    this.indexOfLastOffer = this.currentPage * this.perPage;
                    this.indexOfFirstOffer = this.indexOfLastOffer - this.perPage;
                    this.currentItems = this.filteredItems.slice(this.indexOfFirstOffer, this.indexOfLastOffer);

                    if (this.totalPages < 6) {
                        this.showPages = this.range(1, this.totalPages);
                    } else if (this.currentPage - 2 > 0 && this.currentPage + 2 < this.totalPages) {
                        this.showPages = this.range(this.currentPage - 2, this.currentPage + 2);
                    } else if (this.currentPage - 1 > 0 && this.currentPage + 3 < this.totalPages) {
                        this.showPages = this.range(this.currentPage - 1, this.currentPage + 3);
                    }
                    else if (this.currentPage - 1 < 1) {
                        this.showPages = this.range(1, 5);
                    } else {
                        this.showPages = this.range(this.totalPages - 4, this.totalPages);
                    }
                    setTimeout(() => {
                        this.is_refreshing = false;
                        setTimeout(() => {
                            window.myLazyLoad.update();
                        });
                    },300);

                    this.showPagination = this.filteredItems.length > this.perPage;
                },
                range: function (from, to) {
                    let arr = [];
                    for(let i = from; i <= to; ++i) {
                        arr.push(i);
                    }
                    return arr;
                },
                setCurrentPage: function(page) {
                    this.currentPage = page;
                    this.saveUrl();
                    this.reloadPagination();
                    window.runScroll('#'+el.id);
                },
                nextPage: function() {
                    if(this.currentPage < this.totalPages) {
                        this.setCurrentPage(this.currentPage + 1);
                        this.saveUrl();
                    }
                },
                prevPage: function() {
                    if(this.currentPage > 1) {
                        this.setCurrentPage(this.currentPage - 1);
                        this.saveUrl();
                    }
                },
                saveUrl() {
                    if(el.dataset.newsOnly)
                        return;

                    let url = new URL(window.location.href);

                    url.searchParams.delete('page');
                    url.searchParams.delete('country');
                    url.searchParams.delete('manufacturer');
                    url.searchParams.delete('collection');
                    url.searchParams.delete('category');
                    url.searchParams.delete('is_new');
                    url.searchParams.delete('perPage');
                    url.searchParams.delete('order');

                    if(this.orderBy)
                        url.searchParams.set('order', this.orderBy);
                    if(this.country)
                        url.searchParams.set('country', this.country);
                    if(this.manufacturer)
                        url.searchParams.set('manufacturer', this.manufacturer);
                    if(this.collection)
                        url.searchParams.set('collection', this.collection);
                    if(this.category)
                        url.searchParams.set('category', this.category);
                    if(this.is_new)
                        url.searchParams.set('is_new', this.is_new);
                    if(this.currentPage > 1)
                        url.searchParams.set('page', this.currentPage);
                    if (this.perPage !== 12)
                        url.searchParams.set('perPage', this.perPage);

                    window.history.pushState({}, '', url);
                },
                loadSettingsFromUrl() {
                    if(el.dataset.newsOnly)
                        return;

                    let url = new URL(window.location.href);
                    let doFilter = false;

                    if(url.searchParams.has('order') && this.orderByValues.includes(url.searchParams.get('order'))){
                        this.orderBy = url.searchParams.get('order');
                        doFilter = true;
                    }
                    if(url.searchParams.has('country') && this.countries.includes(url.searchParams.get('country'))){
                        this.country = url.searchParams.get('country');
                        doFilter = true;
                    }
                    if(url.searchParams.has('manufacturer') && this.manufacturers.includes(url.searchParams.get('manufacturer'))) {
                        this.manufacturer = url.searchParams.get('manufacturer');
                        doFilter = true;
                    }
                    if(url.searchParams.has('collection') && this.collections.includes(url.searchParams.get('collection'))) {
                        this.collection = url.searchParams.get('collection');
                        doFilter = true;
                    }
                    if(this.is_flat_categories){
                        if(url.searchParams.has('category') && this.categories.includes(url.searchParams.get('category'))) {
                            this.category = url.searchParams.get('category');
                            doFilter = true;
                        }
                    } else {
                        if (url.searchParams.has('category') && this.categories.some(category => category.key === url.searchParams.get('category'))) {
                            this.category = url.searchParams.get('category');
                            doFilter = true;
                        }
                    }
                    if(url.searchParams.has('is_new')) {
                        this.is_new = url.searchParams.get('is_new');
                        doFilter = true;
                    }
                    if(url.searchParams.has('perPage') && [12,24,48].includes(parseInt(url.searchParams.get('perPage')))) {
                        this.perPage = parseInt(url.searchParams.get('perPage'));
                        doFilter = true;
                        // setTimeout(() => {
                        //     document.querySelector('.custom-select-opener span').innerHTML = this.perPage;
                        // });
                    }
                    if(url.searchParams.has('page')) {
                        this.currentPage = parseInt(url.searchParams.get('page'));
                        doFilter = true;
                    }

                    if(doFilter) {
                        this.filter();
                    }
                    setTimeout(() => {
                        this.init = true;
                    });
                }
            }
        });

        app.component('Select2', Select2);

        if('app-collections' == el.id)
            app.mount('#app-collections')
        if('app-tiles' == el.id)
            app.mount('#app-tiles')
        if('app-armatures' == el.id)
            app.mount('#app-armatures')

    }

    const init = () => {

        const clearFilters = document.querySelector('.js-clearFilters'),
              filters = document.querySelector('.js-filters'),
              checkboxes = filters.querySelectorAll('input'),
              // select = document.getElementsByTagName('select'),
              toggleFilters = document.querySelector('.js-toggleFilters');

        // let cstSel = customSelect(select),
            let count = 0;

        const clickOutside = (e) => {
            if (!e.target.closest('.js-dropdown')) {
                resetDropdown();
        	}
        };

        const countSelected = () => {
            count = 0;
            for (let i = 0; i < checkboxes.length; i++) {
                if ( checkboxes[i].checked ) {
                    count ++;
                }
            }

            for (let i = 0; i < select.length; i++) {
                if ( select[i].value != 0 ) {
                    count ++;
                }
            }

            // count > 0 ? filters.querySelector('.js-counter').innerHTML = '&nbsp;('+count+')' : filters.querySelector('.js-counter').innerHTML = '';
        }

        const monitChanges = () => {
            for (let i = 0; i < checkboxes.length; i++) {
                checkboxes[i].addEventListener('change', countSelected)
            }

            for (let i = 0; i < select.length; i++) {
                select[i].addEventListener('change', countSelected);
            }
        }

        const resetDropdown = (obj) => {
            document.removeEventListener('click', clickOutside);

            for (let i = 0; i < el.length; i ++) {
                if (obj != el[i]) {
                    el[i].removeAttribute('open');
                    el[i].parentNode.removeAttribute('style');
                }
            }
        }

        const openDropdown = (e) => {
            resetDropdown(e.currentTarget);
            document.addEventListener('click', clickOutside);
            e.target.parentNode.parentNode.style.zIndex = '15';
        }

        for (let i = 0; i < el.length; i ++) {
            el[i].addEventListener('click', openDropdown);
        }


        // Init selectors
        // for (let i = 0; i < select.length; i ++) {
        //     cstSel[i].container.addEventListener('custom-select:open', (e) => {
        //         e.target.parentNode.parentNode.style.position = 'relative';
        //         e.target.parentNode.parentNode.style.zIndex = '15';
        //     });
        //
        //     cstSel[i].container.addEventListener('custom-select:close', (e) => {
        //         e.target.parentNode.parentNode.removeAttribute('style');
        //     });
        //
        //     cstSel[i].select.addEventListener('change', (e) => {
        //         if (cstSel[i].value === '0') {
        //             e.target.parentNode.classList.remove('is-active');
        //         } else {
        //             e.target.parentNode.classList.add('is-active');
        //         }
        //     });
        // }

        // Clear all filters
        // po stronie vuejs
        // clearFilters.addEventListener('click', (e) => {
        //     let selectors =  document.querySelectorAll('select');
        //
        //     for (let i = 0; i < checkboxes.length; i++) {
        //         checkboxes[i].checked = false;
        //     }
        //
        //     for (let i = 0; i < cstSel.length; i++) {
        //         cstSel[i].value = 0;
        //     }
        //
        //     countSelected();
        //     e.preventDefault() ? e.preventDefault() : e.preventDefault = false;
        // })

        // Toggle Filters
        const togglePanel = (e) => {
            let _this = e.currentTarget;

            filters.classList.toggle('filters-hidden');

            filters.classList.contains('filters-hidden') ?
                _this.querySelector('span').innerHTML = JSON.parse(e.currentTarget.dataset.names)[0] :
                _this.querySelector('span').innerHTML = JSON.parse(e.currentTarget.dataset.names)[1]

            e.preventDefault() ? e.preventDefault() : e.preventDefault = false;
        }

        toggleFilters.addEventListener('click', togglePanel);

        //po stronie vuejs
        // monitChanges();
    }

    el.length > 0 ? init() : false;

    document.getElementById('app-collections') ? initFilterApp(document.getElementById('app-collections')) : false;
    document.getElementById('app-tiles') ? initFilterApp(document.getElementById('app-tiles')) : false;
    document.getElementById('app-armatures') ? initFilterApp(document.getElementById('app-armatures')) : false;

}, false);
